export default "images/fitlit_sleep_icon.svg";